import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable, retry, lastValueFrom } from 'rxjs';
import { Contest, Store } from '../models/contest';
import { environment } from 'src/environments/environment';
import { AuthService } from './auth.service';
import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root'
})
export class ContestService {

  constructor(public httpClient: HttpClient, private authSvc: AuthService, private configSvc: ConfigService) { }

  /**
   * Returns the list of contests filtered by params
   * @returns Observable<Array<Contest>>
   */
  listContests(active?: boolean, lastActive?:boolean): Observable<Array<Contest>> {
    let url = `${environment.serverUrl}/thoth/campaigns/active/`;
    let params: any = {};
    let headers = this.authSvc.getAuthHeaders();
    if (active) params.active = active;
    if (lastActive) params.last = lastActive;
    return this.httpClient.get<Array<Contest>>(url, headers).pipe(retry(2));
  }


  /**
   * It asks the server to send to your email the bills that you have uploaded
   * @returns Observable<any>
   */
  getUploadedBills(contestId: number): Observable<any> {
    let url = `${environment.serverUrl}/thoth/bills/uploaded`;
    let headers = this.authSvc.getAuthHeaders();

    let body = {
      campaign_id: contestId
    }

    return this.httpClient.post<any>(url, body, headers);
  }

  getStoresByContest(contestId: string): Observable<Array<Store>> {
    let url = `${environment.serverUrl}/thoth/campaigns/stores/${contestId}/`;
    return this.httpClient.get<any>(url, {});
  }

  getStoreByNitAndContest(storeNit: string, contestId: number): Observable<Store> {
    let url = `${environment.serverUrl}/thoth/campaigns/stores/${contestId}`;
    return this.httpClient.get<any>(url, {});
  }

  getStoreByNitAndContest2(contest: Contest): Observable<Store> {
    let contestDocNum = contest.document_number;
    let contestId = contest.id;
    let url = `${environment.serverUrl}/thoth/campaigns/stores/${contestId}`;

    return this.httpClient.get<any[]>(url).pipe(
      map((stores: any[]) => stores.find(store => store.document_number === contestDocNum))
    );
  }

  getUserContestSummary(userId: any, campaingId: any) {
    let url = `${environment.serverUrl}/thoth/bills/user-summary/campaign?user_id=${userId}&campaings_id=${campaingId}`;
    const httpOptions = this.configSvc.getAuthHeaders();
    return lastValueFrom(this.httpClient.get(url, httpOptions)).then(
      (response: any) => {
        return response;
      }
    );
  }

  getUserSummary() {
    let url = `${environment.serverUrl}/thoth/bills/resume-campaigns`;
    const httpOptions = this.configSvc.getAuthHeaders();
    return lastValueFrom(this.httpClient.get(url, httpOptions)).then(
      (response: any) => {
        return response;
      }
    );
  }


  getUserBillsByCustomer(customer_id: any, user_id: any, campaign: any) {
    let url = `${environment.serverUrl}/thoth/bills/list?offset=0&limit=5&customer=${customer_id}&user_id=${user_id}&campaign=${campaign}&resume=true`;
    const httpOptions = this.configSvc.getAuthHeaders();
    return lastValueFrom(this.httpClient.get(url, httpOptions)).then(
      (response: any) => {
        return response;
      }
    );
  }

  listGeneratedTickets(contestId: any): Observable<any> {
    let url = `${environment.serverUrl}/thoth/campaigns/tickets/${contestId}`;
    let liteToken = window.sessionStorage.getItem('lite_token') as any;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + liteToken
      })
    }
    return this.httpClient.get<any>(url, httpOptions);
  }

  sendResumeBills(){
    let url = `${environment.serverUrl}/thoth/bills/send-resume-email`;
    let headers = this.getAuthHeaders();

    return this.httpClient.post<any>(url, {}, headers);
  }

  getAuthHeaders() {
    let sessionToken = window.sessionStorage.getItem('lite_token');
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + sessionToken,
      }),
    };

    return httpOptions;
  }

  getStores(){
    let url = `${environment.serverUrl}/thoth/core/stores/channel`;
    let headers = this.getAuthHeaders();
    return this.httpClient.get<any>(url, headers);
  }

  listContestsEligible(billDate: string | null, storeId: string | undefined) {
    const url = `${environment.serverUrl}/thoth/campaigns/eligible-campaigns`;
    let headers = this.getAuthHeaders();
    const body = {
      bill_date: billDate,
      store_id: storeId
    };
    return this.httpClient.post<any>(url, body, headers);
  }

}

